export interface LocationFormValue {
  latitude?: number;
  longitude?: number;
}

export function hasValidCoords(latitude?: number, longitude?: number): boolean {
  return latitude !== undefined && longitude !== undefined && !isNaN(latitude) && !isNaN(longitude);
}
